let bootstrap = require('bootstrap');
window.bootstrap = bootstrap;